// import { useEffect, useState } from 'react';
// import { fetchData } from '../../../apiService';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, TextField, Grid, Typography, Box, IconButton,
//   FormControl, InputLabel, Select, MenuItem, Divider,
//   useMediaQuery, useTheme, FormHelperText, Snackbar, Alert,
//   CircularProgress, Backdrop, Autocomplete
// } from '@mui/material';
// import { Close, Add, Delete, Inventory, Visibility, CheckCircle, Warning } from '@mui/icons-material';

// const StockTransferInModal = ({
//   open,
//   onClose,
//   modalAction,
//   formData,
//   setFormData,
//   transferDetails,
//   setTransferDetails,
//   onSave,
//   items,
//   branches,
//   loading,
//   companyId,
//   branchId,
//   token,
//   onAccept,
//   onReject
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [itemsModalOpen, setItemsModalOpen] = useState(false);

//   // Validation state
//   const [errors, setErrors] = useState({});
//   const [touched, setTouched] = useState({});
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

//   // Cancel confirmation modal state
//   const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

//   const isViewMode = modalAction === 'view';
//   const title = modalAction === 'create' ? 'Create Stock Transfer In' : modalAction === 'edit' ? 'Edit Stock Transfer In' : 'View Stock Transfer In';

//   // Reset errors when modal opens/closes
//   useEffect(() => {
//     if (open) {
//       setErrors({});
//       setTouched({});
//       setSnackbar({ open: false, message: '', severity: 'error' });
//       setHasUnsavedChanges(false);
//       setCancelConfirmOpen(false);
//     }
//   }, [open, modalAction]);

//   const showError = (message) => {
//     setSnackbar({ open: true, message, severity: 'error' });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar(prev => ({ ...prev, open: false }));
//   };

//   // Handle cancel with confirmation
//   const handleCancelClick = () => {
//     if (hasUnsavedChanges && !isViewMode) {
//       setCancelConfirmOpen(true);
//     } else {
//       onClose();
//     }
//   };

//   const handleConfirmCancel = () => {
//     setCancelConfirmOpen(false);
//     setHasUnsavedChanges(false);
//     onClose();
//   };

//   const handleStayOnPage = () => {
//     setCancelConfirmOpen(false);
//   };

//   // Validation rules
//   const validateField = (field, value) => {
//     switch (field) {
//       case 'TransferNumber':
//         if (!value || value.toString().trim() === '') return 'Transfer Number is required';
//         return '';
//       case 'TransferDate':
//         if (!value) return 'Transfer Date is required';
//         return '';
//       case 'FromBranchId':
//         if (!value) return 'From Branch is required';
//         return '';
//       default:
//         return '';
//     }
//   };

//   // Validate all fields
//   const validateForm = () => {
//     const newErrors = {};

//     // Required field validations
//     const transferNumberError = validateField('TransferNumber', formData.TransferNumber);
//     if (transferNumberError) newErrors.TransferNumber = transferNumberError;

//     const transferDateError = validateField('TransferDate', formData.TransferDate);
//     if (transferDateError) newErrors.TransferDate = transferDateError;

//     const fromBranchError = validateField('FromBranchId', formData.FromBranchId);
//     if (fromBranchError) newErrors.FromBranchId = fromBranchError;

//     // Transfer details validation
//     if (transferDetails.length === 0) {
//       newErrors.transferDetails = 'At least one item is required';
//     } else {
//       const detailErrors = [];
//       transferDetails.forEach((detail, index) => {
//         const itemErrors = {};
//         if (!detail.ItemId) itemErrors.ItemId = 'Item is required';
//         if (!detail.Quantity || parseFloat(detail.Quantity) <= 0) {
//           itemErrors.Quantity = 'Quantity must be greater than 0';
//         }
//         if (!detail.Rate || parseFloat(detail.Rate) <= 0) {
//           itemErrors.Rate = 'Rate must be greater than 0';
//         }
//         if (Object.keys(itemErrors).length > 0) {
//           detailErrors[index] = itemErrors;
//         }
//       });
//       if (detailErrors.length > 0) {
//         newErrors.details = detailErrors;
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle field blur for touched state
//   const handleBlur = (field) => {
//     setTouched(prev => ({ ...prev, [field]: true }));
//     const error = validateField(field, formData[field]);
//     setErrors(prev => ({ ...prev, [field]: error }));
//   };

//   // Handle save with validation
//   const handleSaveWithValidation = () => {
//     // Mark all fields as touched
//     setTouched({ TransferNumber: true, TransferDate: true, FromBranchId: true });

//     // Build validation error messages
//     const validationMessages = [];

//     if (!formData.TransferNumber || formData.TransferNumber.toString().trim() === '') {
//       validationMessages.push('Transfer Number is required');
//     }
//     if (!formData.TransferDate) {
//       validationMessages.push('Transfer Date is required');
//     }
//     if (!formData.FromBranchId) {
//       validationMessages.push('From Branch is required');
//     }
//     if (transferDetails.length === 0) {
//       validationMessages.push('At least one item is required');
//     } else {
//       // Check each item for Quantity and Rate
//       const itemErrors = [];
//       transferDetails.forEach((detail, index) => {
//         if (!detail.ItemId) {
//           itemErrors.push(`Row ${index + 1}: Item is required`);
//         }
//         if (!detail.Quantity || parseFloat(detail.Quantity) <= 0) {
//           itemErrors.push(`Row ${index + 1}: Quantity is required`);
//         }
//         if (!detail.Rate || parseFloat(detail.Rate) <= 0) {
//           itemErrors.push(`Row ${index + 1}: Rate is required`);
//         }
//       });
//       if (itemErrors.length > 0) {
//         validationMessages.push(...itemErrors);
//       }
//     }

//     if (validationMessages.length > 0) {
//       showError(validationMessages.join(' | '));
//       validateForm();
//       return;
//     }

//     if (validateForm()) {
//       onSave();
//     }
//   };

//   const handleChange = (field, value) => {
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: '' }));
//     }

//     // Mark as having unsaved changes
//     if (!isViewMode) {
//       setHasUnsavedChanges(true);
//     }

//     setFormData(prev => ({ ...prev, [field]: value }));
//   };

//   const handleDetailChange = (index, field, value) => {
//     // Mark as having unsaved changes
//     if (!isViewMode) {
//       setHasUnsavedChanges(true);
//     }

//     const updatedDetails = [...transferDetails];

//     if (['Quantity', 'Rate'].includes(field)) {
//       if (value === '' || value === null || value === undefined) {
//         updatedDetails[index] = { ...updatedDetails[index], [field]: '' };
//         setTransferDetails(updatedDetails);
//         calculateTotals(updatedDetails);
//         return;
//       }
//       const validNumberRegex = /^\d*\.?\d*$/;
//       if (!validNumberRegex.test(value)) return;
//       const numValue = parseFloat(value);
//       if (isNaN(numValue) || numValue < 0) return;
//     }

//     updatedDetails[index] = { ...updatedDetails[index], [field]: value };

//     if (['Quantity', 'Rate'].includes(field)) {
//       const detail = updatedDetails[index];
//       const quantity = Math.max(0, parseFloat(detail.Quantity) || 0);
//       const rate = Math.max(0, parseFloat(detail.Rate) || 0);
//       const amount = quantity * rate;

//       updatedDetails[index] = {
//         ...updatedDetails[index],
//         Amount: amount
//       };
//     }
//     setTransferDetails(updatedDetails);
//     calculateTotals(updatedDetails);
//   };

//   const handleItemSelect = (index, itemId) => {
//     // Check if item is already selected in another row
//     const isDuplicate = transferDetails.some((detail, i) => 
//       i !== index && detail.ItemId === parseInt(itemId)
//     );
    
//     if (isDuplicate) {
//       showError('This item is already added to the table. Please select a different item.');
//       return;
//     }

//     const selectedItem = items.find(i => i.Id === parseInt(itemId));
//     if (selectedItem) {
//       const updatedDetails = [...transferDetails];
//       const quantity = parseFloat(updatedDetails[index].Quantity) || 0;
//       const rate = selectedItem.PurchaseRate || selectedItem.Rate || 0;
//       const amount = quantity * rate;

//       updatedDetails[index] = {
//         ...updatedDetails[index],
//         ItemId: itemId,
//         Rate: rate,
//         Amount: amount
//       };
//       setTransferDetails(updatedDetails);
//       calculateTotals(updatedDetails);
//     }
//   };

//   const addDetailRow = () => {
//     setHasUnsavedChanges(true);
//     setTransferDetails([{
//       Id: 0, 
//       ItemId: '', 
//       Quantity: 0, 
//       Rate: 0, 
//       Amount: 0, 
//       IsActive: true
//     }, ...transferDetails]);
//   };

//   const removeDetailRow = (index) => {
//     setHasUnsavedChanges(true);
//     const updatedDetails = transferDetails.filter((_, i) => i !== index);
//     setTransferDetails(updatedDetails);
//     calculateTotals(updatedDetails);
//   };

//   const calculateTotals = (details) => {
//     const totals = details.reduce((acc, d) => ({
//       TotalQuantity: acc.TotalQuantity + (parseFloat(d.Quantity) || 0),
//       TotalAmount: acc.TotalAmount + (parseFloat(d.Amount) || 0)
//     }), { TotalQuantity: 0, TotalAmount: 0 });

//     setFormData(prev => ({
//       ...prev,
//       ...totals
//     }));
//   };

//   useEffect(() => {
//     // Auto-calculate totals when details change (length or any quantity/amount value)
//     if (!isViewMode) {
//       if (transferDetails.length > 0) {
//         calculateTotals(transferDetails);
//       } else {
//         // All rows removed — reset totals to zero
//         setFormData(prev => ({ ...prev, TotalQuantity: 0, TotalAmount: 0 }));
//       }
//     }
//   }, [
//     transferDetails.length,
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     transferDetails.map(d => `${d.Quantity}|${d.Rate}`).join(',')
//   ]);

//   const formatCurrency = (amt) => `₹${(amt || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

//   const disabledFieldStyle = { '& .MuiInputBase-input.Mui-disabled': { color: '#5D4037', fontWeight: 700, WebkitTextFillColor: '#5D4037' } };

//   // Handle View All Items modal opening
//   const handleViewAllItemsOpen = () => {
//     setItemsModalOpen(true);
//   };

//   const handleViewAllItemsClose = () => {
//     setItemsModalOpen(false);
//   };

//   const compactInput = { '& .MuiInputBase-input': { py: 0.75, fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' }, ...(isViewMode && disabledFieldStyle) };

//   return (
//     <Dialog open={open} onClose={(e, reason) => {
//       if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
//         if (hasUnsavedChanges && !isViewMode) {
//           setCancelConfirmOpen(true);
//           return;
//         }
//       }
//       onClose();
//     }}
//       maxWidth="xl" fullWidth fullScreen={isMobile} disableEscapeKeyDown
//       PaperProps={{ sx: { borderRadius: isMobile ? 0 : '10px', m: isMobile ? 0 : 2, maxWidth: '1400px', position: 'relative' } }}>

//       <DialogTitle sx={{ py: 1, px: 2, borderBottom: isViewMode ? '1px solid #e2e8f0' : '1px solid #d1d5db', bgcolor: isViewMode ? '#1e293b' : '#f8f4ff' }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Inventory sx={{ color: isViewMode ? '#f8fafc' : '#8b5cf6', fontSize: 20 }} />
//             <Typography variant="subtitle1" sx={{ fontWeight: 600, color: isViewMode ? '#f8fafc' : '#5b21b6', fontSize: isMobile ? '0.9rem' : '1rem' }}>{title}</Typography>
//           </Box>
//           <IconButton onClick={handleCancelClick} size="small" sx={{ p: 0.5, color: isViewMode ? '#f8fafc' : 'inherit' }}><Close fontSize="small" /></IconButton>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: isMobile ? 1.5 : 2, bgcolor: isViewMode ? '#f8fafc' : '#fefffe' }}>
//         <Typography variant="caption" sx={{ fontWeight: 600, color: isViewMode ? '#475569' : '#8b5cf6', mb: 1, display: 'block' }}>Transfer Information</Typography>
//         <Grid container spacing={1} sx={{ mb: 1.5 }}>
//           <Grid item xs={6} sm={2}>
//             <TextField
//               fullWidth
//               size="small"
//               label="Transfer No *"
//               value={formData.TransferPrefix && formData.FinYear 
//                 ? `${formData.TransferPrefix}/${formData.TransferNumber}/${formData.FinYear}`
//                 : formData.TransferNumber || ''}
//               onChange={(e) => handleChange('TransferNumber', e.target.value)}
//               onBlur={() => handleBlur('TransferNumber')}
//               disabled={isViewMode}
//               error={touched.TransferNumber && !!errors.TransferNumber}
//               helperText={touched.TransferNumber && errors.TransferNumber}
//               sx={compactInput}
//             />
//           </Grid>
//           <Grid item xs={6} sm={2}>
//             <TextField
//               fullWidth
//               size="small"
//               type="date"
//               label="Transfer Date *"
//               value={formData.TransferDate || ''}
//               onChange={(e) => handleChange('TransferDate', e.target.value)}
//               onBlur={() => handleBlur('TransferDate')}
//               disabled={isViewMode}
//               error={touched.TransferDate && !!errors.TransferDate}
//               helperText={touched.TransferDate && errors.TransferDate}
//               InputLabelProps={{ shrink: true }}
//               sx={compactInput}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             {isViewMode ? (
//               <TextField fullWidth size="small" label="From Branch" value={branches.find(b => b.Id === formData.FromBranchId)?.Name || '-'} disabled sx={{ ...compactInput, ...disabledFieldStyle }} />
//             ) : (
//               <FormControl fullWidth size="small" sx={compactInput} error={touched.FromBranchId && !!errors.FromBranchId}>
//                 <InputLabel>From Branch *</InputLabel>
//                 <Select
//                   value={formData.FromBranchId || ''}
//                   onChange={(e) => handleChange('FromBranchId', e.target.value)}
//                   onBlur={() => handleBlur('FromBranchId')}
//                   label="From Branch *"
//                   sx={{ fontSize: '0.8rem' }}
//                   MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.85rem' } } } }}
//                 >
//                   {branches.filter(b => b.Id !== branchId).map(branch => (
//                     <MenuItem key={branch.Id} value={branch.Id} sx={{ fontSize: '0.85rem', py: 0.5 }}>
//                       {branch.Name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 {touched.FromBranchId && errors.FromBranchId && (
//                   <FormHelperText>{errors.FromBranchId}</FormHelperText>
//                 )}
//               </FormControl>
//             )}
//           </Grid>
//           <Grid item xs={12} sm={5}>
//             <TextField
//               fullWidth
//               size="small"
//               label="Remarks"
//               value={formData.Remarks || ''}
//               onChange={(e) => handleChange('Remarks', e.target.value)}
//               disabled={isViewMode}
//               sx={compactInput}
//             />
//           </Grid>
//         </Grid>

//         <Divider sx={{ my: 1 }} />

//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Typography variant="caption" sx={{ fontWeight: 600, color: errors.transferDetails ? '#dc2626' : (isViewMode ? '#475569' : '#8b5cf6') }}>Transfer Items *</Typography>
//             <Typography variant="caption" sx={{ color: '#6b7280' }}>({transferDetails.length} items)</Typography>
//             {errors.transferDetails && (
//               <Typography variant="caption" sx={{ color: '#dc2626', fontSize: '0.7rem' }}>({errors.transferDetails})</Typography>
//             )}
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             {transferDetails.length > 5 && (
//               <Button
//                 size="small"
//                 onClick={handleViewAllItemsOpen}
//                 startIcon={<Visibility sx={{ fontSize: 14 }} />}
//                 sx={{ py: 0.25, px: 1, fontSize: '0.7rem', minHeight: 0, color: '#1e40af' }}
//               >
//                 View All
//               </Button>
//             )}
//             {/* {!isViewMode && (
//               <Button size="small" startIcon={<Add sx={{ fontSize: 16 }} />} onClick={addDetailRow} variant="outlined" sx={{ py: 0.25, px: 1, fontSize: '0.7rem', minHeight: 0 }}>Add</Button>
//             )} */}
//           </Box>
//         </Box>

//         {/* Desktop Table View - Fixed height for 5 rows */}
//         {!isMobile && (
//           <Box sx={{ maxHeight: 200, overflow: 'auto', mb: 1.5, border: errors.transferDetails ? '1px solid #dc2626' : (isViewMode ? '1px solid #e2e8f0' : '1px solid #d1d5db'), borderRadius: 1 }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
//               <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
//                 <tr style={{ background: isViewMode ? 'linear-gradient(135deg, #334155 0%, #1e293b 100%)' : 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
//                   <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #d1d5db', width: '4%', background: 'transparent', color: 'white', fontWeight: 600 }}>Sl No</th>
//                   <th style={{ padding: '6px 8px', textAlign: 'left', borderBottom: '1px solid #d1d5db', width: '40%', background: 'transparent', color: 'white', fontWeight: 600 }}>Item</th>
//                   <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #d1d5db', width: '15%', background: 'transparent', color: 'white', fontWeight: 600 }}>Quantity</th>
//                   <th style={{ padding: '6px 8px', textAlign: 'right', borderBottom: '1px solid #d1d5db', width: '15%', background: 'transparent', color: 'white', fontWeight: 600 }}>Rate</th>
//                   <th style={{ padding: '6px 8px', textAlign: 'right', borderBottom: '1px solid #d1d5db', width: '20%', background: 'transparent', color: 'white', fontWeight: 600 }}>Amount</th>
//                   {!isViewMode && <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #d1d5db', width: '6%', background: 'transparent', color: 'white', fontWeight: 600 }}></th>}
//                 </tr>
//               </thead>
//               <tbody>
//                 {transferDetails.map((d, index) => (
//                   <tr key={index} style={{ backgroundColor: index % 2 === 0 ? (isViewMode ? '#f1f5f9' : '#f8f4ff') : '#ffffff' }}>
//                     <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'center', fontWeight: 600, color: isViewMode ? '#475569' : '#8b5cf6' }}>
//                       {index + 1}
//                     </td>
//                     {/* <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', fontWeight: isViewMode ? 600 : 400 }}>
//                       {isViewMode ? (
//                         <span style={{ fontWeight: 600, color: '#5b21b6' }}>{items.find(i => i.Id === parseInt(d.ItemId))?.Name || '-'}</span>
//                       ) : (
//                         <Select fullWidth size="small" value={d.ItemId || ''} onChange={(e) => handleItemSelect(index, e.target.value)} sx={{ fontSize: '0.85rem', '& .MuiSelect-select': { py: 0.5 } }} MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.85rem' } } } }}>
//                           <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}>Select</MenuItem>
//                           {items.map(item => {
//                             const isAlreadySelected = transferDetails.some((detail, i) => 
//                               i !== index && detail.ItemId === item.Id
//                             );
//                             return (
//                               <MenuItem 
//                                 key={item.Id} 
//                                 value={item.Id} 
//                                 disabled={isAlreadySelected}
//                                 sx={{ 
//                                   fontSize: '0.85rem', 
//                                   py: 0.25,
//                                   opacity: isAlreadySelected ? 0.5 : 1,
//                                   color: isAlreadySelected ? '#9ca3af' : 'inherit'
//                                 }}
//                               >
//                                 {item.Name} {isAlreadySelected && '(Already Added)'}
//                               </MenuItem>
//                             );
//                           })}
//                         </Select>
//                       )}
//                     </td> */}
//                     <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', fontWeight: isViewMode ? 600 : 400 }}>
//                         <span style={{ fontWeight: 600, color: '#5b21b6' }}>{items.find(i => i.Id === parseInt(d.ItemId))?.Name || '-'}</span>
//                     </td>
//                     <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'center', fontWeight: isViewMode ? 600 : 400 }}>
//                       {isViewMode ? (
//                         <span style={{ fontWeight: 600, color: '#5b21b6' }}>{d.Quantity || 0}</span>
//                       ) : (
//                         <TextField size="small" type="number" value={d.Quantity ?? ''} onChange={(e) => handleDetailChange(index, 'Quantity', e.target.value)} disabled={isViewMode} onFocus={(e) => e.target.select()} inputProps={{ min: 0, style: { textAlign: 'center', padding: '4px', fontSize: '0.75rem' } }} sx={{ width: '100%' }} />
//                       )}
//                     </td>
//                     <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'right', fontWeight: isViewMode ? 600 : 400 }}>
//                       {isViewMode ? (
//                         <span style={{ fontWeight: 600, color: '#5b21b6' }}>{formatCurrency(d.Rate)}</span>
//                       ) : (
//                         <TextField size="small" type="number" value={d.Rate ?? ''} onChange={(e) => handleDetailChange(index, 'Rate', e.target.value)} disabled={isViewMode} onFocus={(e) => e.target.select()} inputProps={{ min: 0, style: { textAlign: 'right', padding: '4px', fontSize: '0.75rem' } }} sx={{ width: '100%' }} />
//                       )}
//                     </td>
//                     <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'right', fontWeight: 600, color: '#8b5cf6' }}>{formatCurrency(d.Amount)}</td>
//                     {!isViewMode && (
//                       <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'center' }}>
//                         <IconButton size="small" onClick={() => removeDetailRow(index)} sx={{ p: 0.25, color: '#dc2626' }}><Delete sx={{ fontSize: 16 }} /></IconButton>
//                       </td>
//                     )}
//                   </tr>
//                 ))}
//                 {transferDetails.length === 0 && (
//                   <tr><td colSpan={isViewMode ? 5 : 6} style={{ padding: '20px', textAlign: 'center', color: '#6b7280', backgroundColor: isViewMode ? '#f1f5f9' : '#f8f4ff' }}>No items added</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </Box>
//         )}

//         {/* Mobile Card View */}
//         {isMobile && (
//           <Box sx={{ maxHeight: 300, overflow: 'auto', mb: 1.5 }}>
//             {transferDetails.map((d, index) => (
//               <Box key={index} sx={{ border: '1px solid #d1d5db', borderRadius: 2, p: 1.5, mb: 1.5, bgcolor: '#f8f4ff' }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                   <Typography variant="body2" sx={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.8rem' }}>
//                     {items.find(i => i.Id === parseInt(d.ItemId))?.Name || 'Select Item'}
//                   </Typography>
//                   {!isViewMode && (
//                     <IconButton size="small" onClick={() => removeDetailRow(index)} sx={{ p: 0.5, bgcolor: '#fef2f2', color: '#dc2626' }}><Delete sx={{ fontSize: 16 }} /></IconButton>
//                   )}
//                 </Box>
//                 {!isViewMode && (
//                   <FormControl fullWidth size="small" sx={{ mb: 1 }}>
//                     <InputLabel sx={{ fontSize: '0.75rem' }}>Select Item</InputLabel>
//                     <Select value={d.ItemId || ''} onChange={(e) => handleItemSelect(index, e.target.value)} label="Select Item" sx={{ fontSize: '0.85rem' }} MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.85rem' } } } }}>
//                       {items.map(item => {
//                         const isAlreadySelected = transferDetails.some((detail, i) => 
//                           i !== index && detail.ItemId === item.Id
//                         );
//                         return (
//                           <MenuItem 
//                             key={item.Id} 
//                             value={item.Id} 
//                             disabled={isAlreadySelected}
//                             sx={{ 
//                               fontSize: '0.85rem', 
//                               py: 0.5,
//                               opacity: isAlreadySelected ? 0.5 : 1,
//                               color: isAlreadySelected ? '#9ca3af' : 'inherit'
//                             }}
//                           >
//                             {item.Name} {isAlreadySelected && '(Already Added)'}
//                           </MenuItem>
//                         );
//                       })}
//                     </Select>
//                   </FormControl>
//                 )}
//                 <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="caption" sx={{ color: '#8b5cf6', fontSize: '0.65rem', fontWeight: 600 }}>Quantity</Typography>
//                     <TextField size="small" type="number" value={d.Quantity || ''} onChange={(e) => handleDetailChange(index, 'Quantity', e.target.value)} disabled={isViewMode} fullWidth inputProps={{ min: 0 }} sx={{ '& .MuiInputBase-input': { py: 0.75, fontSize: '0.8rem', textAlign: 'center' } }} />
//                   </Box>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="caption" sx={{ color: '#8b5cf6', fontSize: '0.65rem', fontWeight: 600 }}>Rate</Typography>
//                     <TextField size="small" type="number" value={d.Rate || ''} onChange={(e) => handleDetailChange(index, 'Rate', e.target.value)} disabled={isViewMode} fullWidth inputProps={{ min: 0 }} sx={{ '& .MuiInputBase-input': { py: 0.75, fontSize: '0.8rem', textAlign: 'right' } }} />
//                   </Box>
//                 </Box>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 1, borderTop: '1px solid #d1d5db' }}>
//                   <Typography variant="caption" sx={{ color: '#8b5cf6', fontWeight: 600 }}>Amount</Typography>
//                   <Typography variant="body2" sx={{ fontWeight: 600, color: '#8b5cf6' }}>{formatCurrency(d.Amount)}</Typography>
//                 </Box>
//               </Box>
//             ))}
//             {transferDetails.length === 0 && (
//               <Box sx={{ textAlign: 'center', py: 4, color: '#8b5cf6', bgcolor: '#f8f4ff', borderRadius: 1, border: '1px dashed #d1d5db' }}><Typography variant="body2">No items added</Typography></Box>
//             )}
//           </Box>
//         )}

//         <Divider sx={{ my: 1 }} />

//         {/* Summary Section */}
//         <Grid container spacing={1}>
//           <Grid item xs={12} sm={8}>
//             {/* Audit Info */}
//             {isViewMode && (
//               <Box sx={{ bgcolor: '#f1f5f9', p: 1.5, borderRadius: 1 }}>
//                 {(formData.InputAccepted != null || formData.InputRejected != null) && (
//                   <Box sx={{ display: 'flex', gap: 2, mb: 1, pb: 1, borderBottom: '1px solid #e2e8f0' }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                       <CheckCircle sx={{ fontSize: 14, color: '#16a34a' }} />
//                       <Typography variant="caption" sx={{ color: '#16a34a', fontWeight: 600 }}>Accepted: {formData.InputAccepted ?? 0}</Typography>
//                     </Box>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                       <Warning sx={{ fontSize: 14, color: formData.InputRejected > 0 ? '#dc2626' : '#9ca3af' }} />
//                       <Typography variant="caption" sx={{ color: formData.InputRejected > 0 ? '#dc2626' : '#9ca3af', fontWeight: 600 }}>Rejected: {formData.InputRejected ?? 0}</Typography>
//                     </Box>
//                   </Box>
//                 )}
//                 <Typography variant="caption" sx={{ color: '#6b7280', display: 'block' }}>
//                   Created by <Typography component="span" variant="caption" sx={{ fontWeight: 600, color: '#8b5cf6' }}>{formData.CreatedByName || '-'}</Typography> on{' '}
//                   <Typography component="span" variant="caption" sx={{ color: '#7c3aed' }}>
//                     {formData.CreatedDate ? new Date(formData.CreatedDate).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ', ' + new Date(formData.CreatedDate).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}
//                   </Typography>
//                 </Typography>
//                 <Typography variant="caption" sx={{ color: '#6b7280', display: 'block' }}>
//                   Modified by <Typography component="span" variant="caption" sx={{ fontWeight: 600, color: '#7c3aed' }}>{formData.ModifiedByName || '-'}</Typography> on{' '}
//                   <Typography component="span" variant="caption" sx={{ color: '#6d28d9' }}>
//                     {formData.ModifiedDate ? new Date(formData.ModifiedDate).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ', ' + new Date(formData.ModifiedDate).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}
//                   </Typography>
//                 </Typography>
//               </Box>
//             )}
//           </Grid>

//           <Grid item xs={12} sm={4}>
//             <Typography variant="caption" sx={{ fontWeight: 600, color: isViewMode ? '#475569' : '#8b5cf6', mb: 1, display: 'block' }}>Summary</Typography>
//             <Box sx={{ bgcolor: isViewMode ? '#f1f5f9' : '#f8f4ff', p: 1.5, borderRadius: 1 }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                 <Typography variant="caption">Total Quantity</Typography>
//                 <Typography variant="caption" sx={{ fontWeight: 600, color: '#8b5cf6' }}>{formData.TotalQuantity || 0}</Typography>
//               </Box>
//               <Divider sx={{ my: 0.5 }} />
//               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Total Amount</Typography>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#8b5cf6' }}>{formatCurrency(formData.TotalAmount)}</Typography>
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>

//       </DialogContent>

//       <DialogActions sx={{ px: 2, py: 1.5, borderTop: isViewMode ? '1px solid #e2e8f0' : '1px solid #d1d5db', bgcolor: isViewMode ? '#f8fafc' : '#f8f4ff' }}>
//         <Button onClick={handleCancelClick} variant="outlined" size="small">Cancel</Button>
//         {isViewMode && onAccept && !formData.InputAccepted && (
//           <Button onClick={() => onAccept(formData.Id)} variant="contained" size="small"
//             sx={{ bgcolor: '#16a34a', '&:hover': { bgcolor: '#15803d' }, textTransform: 'none' }}>
//             Accept
//           </Button>
//         )}
//         {isViewMode && onReject && !formData.InputAccepted && (
//           <Button onClick={() => onReject(formData.Id)} variant="contained" size="small"
//             sx={{ bgcolor: '#dc2626', '&:hover': { bgcolor: '#b91c1c' }, textTransform: 'none' }}>
//             Reject
//           </Button>
//         )}
//         {!isViewMode && <Button onClick={handleSaveWithValidation} variant="contained" size="small" disabled={loading}>Save</Button>}
//       </DialogActions>

//       {/* View All Items Modal */}
//       <Dialog 
//         open={itemsModalOpen} 
//         onClose={handleViewAllItemsClose} 
//         maxWidth="lg"
//         fullWidth 
//         PaperProps={{ 
//           sx: { 
//             borderRadius: '12px', 
//             maxHeight: '90vh', 
//             position: 'relative', 
//             m: 1
//           } 
//         }}
//       >
//         <DialogTitle sx={{ py: 1, px: 1.5, borderBottom: '1px solid #d1d5db', bgcolor: '#f8f4ff' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Inventory sx={{ color: '#8b5cf6', fontSize: 18 }} />
//               <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.9rem' }}>All Transfer Items ({transferDetails.length})</Typography>
//             </Box>
//             {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//               {!isViewMode && (
//                 <Button 
//                   onClick={addDetailRow} 
//                   variant="contained" 
//                   size="small" 
//                   startIcon={<Add sx={{ fontSize: 14 }} />}
//                   sx={{ 
//                     bgcolor: '#8b5cf6', 
//                     '&:hover': { bgcolor: '#7c3aed' },
//                     fontSize: '0.7rem',
//                     py: 0.4,
//                     px: 1,
//                     minHeight: 0
//                   }}
//                 >
//                   Add Item
//                 </Button>
//               )}
//               <IconButton onClick={handleViewAllItemsClose} size="small" sx={{ p: 0.4 }}><Close fontSize="small" /></IconButton>
//             </Box> */}
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0 }}>
//           <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
//               <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
//                 <tr style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
//                   <th style={{ padding: '8px 6px', textAlign: 'center', color: 'white', fontWeight: 600, fontSize: '0.7rem' }}>#</th>
//                   <th style={{ padding: '8px 8px', textAlign: 'left', color: 'white', fontWeight: 600, fontSize: '0.7rem', minWidth: '200px' }}>Item Name</th>
//                   <th style={{ padding: '8px 6px', textAlign: 'center', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '100px' }}>Quantity</th>
//                   <th style={{ padding: '8px 6px', textAlign: 'right', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '100px' }}>Rate</th>
//                   <th style={{ padding: '8px 6px', textAlign: 'right', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '120px' }}>Amount</th>
//                   {!isViewMode && <th style={{ padding: '8px 6px', textAlign: 'center', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '50px' }}>Action</th>}
//                 </tr>
//               </thead>
//               <tbody>
//                 {transferDetails.map((d, index) => (
//                   <tr key={index} style={{ background: index % 2 === 0 ? '#f8f4ff' : '#ffffff', borderBottom: '1px solid #d1d5db' }}>
//                     <td style={{ padding: '6px', textAlign: 'center', fontWeight: 500, color: '#8b5cf6', fontSize: '0.75rem' }}>{index + 1}</td>
//                     <td style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 500, color: '#5b21b6' }}>
//                       {isViewMode ? (
//                         <span style={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.75rem' }}>{items.find(i => i.Id === parseInt(d.ItemId))?.Name || '-'}</span>
//                       ) : (
//                         <Select 
//                           fullWidth 
//                           size="small" 
//                           value={d.ItemId || ''} 
//                           onChange={(e) => handleItemSelect(index, e.target.value)} 
//                           sx={{ 
//                             fontSize: '0.75rem', 
//                             minWidth: '180px',
//                             '& .MuiSelect-select': { py: 0.4, fontSize: '0.75rem' } 
//                           }} 
//                           MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.75rem', py: 0.4 } } } }}
//                         >
//                           <MenuItem value="" disabled sx={{ fontSize: '0.75rem' }}>Select Item</MenuItem>
//                           {items.map(item => {
//                             const isAlreadySelected = transferDetails.some((detail, i) => 
//                               i !== index && detail.ItemId === item.Id
//                             );
//                             return (
//                               <MenuItem 
//                                 key={item.Id} 
//                                 value={item.Id} 
//                                 disabled={isAlreadySelected}
//                                 sx={{ 
//                                   fontSize: '0.75rem', 
//                                   py: 0.2,
//                                   opacity: isAlreadySelected ? 0.5 : 1,
//                                   color: isAlreadySelected ? '#9ca3af' : 'inherit'
//                                 }}
//                               >
//                                 {item.Name} {isAlreadySelected && '(Already Added)'}
//                               </MenuItem>
//                             );
//                           })}
//                         </Select>
//                       )}
//                     </td>
//                     <td style={{ padding: '6px', textAlign: 'center', fontWeight: 600, color: '#5b21b6' }}>
//                       {isViewMode ? (
//                         <span style={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.75rem' }}>{d.Quantity || 0}</span>
//                       ) : (
//                         <TextField 
//                           size="small" 
//                           type="number" 
//                           value={d.Quantity ?? ''} 
//                           onChange={(e) => handleDetailChange(index, 'Quantity', e.target.value)} 
//                           onFocus={(e) => e.target.select()} 
//                           inputProps={{ 
//                             min: 0, 
//                             style: { textAlign: 'center', padding: '3px', fontSize: '0.7rem' },
//                             onKeyDown: (e) => {
//                               if (e.key === 'Enter') {
//                                 e.target.blur();
//                               }
//                             }
//                           }} 
//                           sx={{ 
//                             width: '80px', 
//                             '& .MuiOutlinedInput-root': { height: '28px' },
//                             '& input': {
//                               transition: 'none'
//                             }
//                           }} 
//                         />
//                       )}
//                     </td>
//                     <td style={{ padding: '6px', textAlign: 'right', fontWeight: 600, color: '#5b21b6' }}>
//                       {isViewMode ? (
//                         <span style={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.75rem' }}>{formatCurrency(d.Rate)}</span>
//                       ) : (
//                         <TextField 
//                           size="small" 
//                           type="number" 
//                           value={d.Rate ?? ''} 
//                           onChange={(e) => handleDetailChange(index, 'Rate', e.target.value)} 
//                           onFocus={(e) => e.target.select()} 
//                           inputProps={{ 
//                             min: 0, 
//                             style: { textAlign: 'right', padding: '3px', fontSize: '0.7rem' },
//                             onKeyDown: (e) => {
//                               if (e.key === 'Enter') {
//                                 e.target.blur();
//                               }
//                             }
//                           }} 
//                           sx={{ 
//                             width: '90px', 
//                             '& .MuiOutlinedInput-root': { height: '28px' },
//                             '& input': {
//                               transition: 'none'
//                             }
//                           }} 
//                         />
//                       )}
//                     </td>
//                     <td style={{ padding: '6px', textAlign: 'right', fontWeight: 700, color: '#8b5cf6', fontSize: '0.75rem' }}>{formatCurrency(d.Amount)}</td>
//                     {!isViewMode && (
//                       <td style={{ padding: '6px', textAlign: 'center' }}>
//                         <IconButton 
//                           size="small" 
//                           onClick={() => removeDetailRow(index)} 
//                           sx={{ p: 0.2, color: '#dc2626', '&:hover': { bgcolor: '#fef2f2' } }}
//                         >
//                           <Delete sx={{ fontSize: 14 }} />
//                         </IconButton>
//                       </td>
//                     )}
//                   </tr>
//                 ))}
//                 {transferDetails.length === 0 && (
//                   <tr>
//                     <td colSpan={isViewMode ? 5 : 6} style={{ padding: '16px', textAlign: 'center', color: '#6b7280', backgroundColor: '#f8f4ff', fontSize: '0.8rem' }}>
//                       No items added
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//               <tfoot style={{ position: 'sticky', bottom: 0, background: 'linear-gradient(135deg, #e9d5ff 0%, #ddd6fe 100%)' }}>
//                 <tr style={{ borderTop: '2px solid #8b5cf6' }}>
//                   <td colSpan="2" style={{ padding: '8px 6px', fontWeight: 700, textAlign: 'right', color: '#5b21b6', fontSize: '0.75rem' }}>Totals:</td>
//                   <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 700, color: '#8b5cf6', fontSize: '0.75rem' }}>{transferDetails.reduce((sum, d) => sum + (parseFloat(d.Quantity) || 0), 0)}</td>
//                   <td colSpan="1"></td>
//                   <td style={{ padding: '8px 6px', textAlign: 'right', fontWeight: 700, color: '#8b5cf6', fontSize: '0.75rem' }}>{formatCurrency(transferDetails.reduce((sum, d) => sum + (parseFloat(d.Amount) || 0), 0))}</td>
//                   {!isViewMode && <td style={{ padding: '8px 6px' }}></td>}
//                 </tr>
//               </tfoot>
//             </table>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 1.5, py: 1, borderTop: '1px solid #d1d5db', bgcolor: '#f8f4ff', justifyContent: 'flex-end' }}>
//           <Button onClick={handleViewAllItemsClose} variant="outlined" size="small" sx={{ fontSize: '0.75rem', py: 0.4, px: 1.5 }}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Validation Error Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       {/* Cancel Confirmation Modal */}
//       <Dialog
//         open={cancelConfirmOpen}
//         onClose={handleStayOnPage}
//         maxWidth="xs"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: '12px', padding: '8px' } }}
//       >
//         <DialogTitle sx={{ pb: 1 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//             <Box sx={{
//               backgroundColor: '#fef3c7',
//               borderRadius: '50%',
//               width: 40,
//               height: 40,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}>
//               <Warning sx={{ color: '#f59e0b', fontSize: 24 }} />
//             </Box>
//             <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b' }}>
//               Unsaved Changes
//             </Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography sx={{ color: '#64748b', fontSize: '0.9rem' }}>
//             You have unsaved changes that will be lost if you leave this page.
//           </Typography>
//           <Typography sx={{ color: '#dc2626', fontSize: '0.85rem', mt: 1, fontWeight: 500 }}>
//             Are you sure you want to exit without saving?
//           </Typography>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
//           <Button
//             onClick={handleStayOnPage}
//             variant="outlined"
//             sx={{
//               borderColor: '#8b5cf6',
//               color: '#8b5cf6',
//               '&:hover': { borderColor: '#7c3aed', backgroundColor: '#f8f4ff' }
//             }}
//           >
//             Stay on Page
//           </Button>
//           <Button
//             onClick={handleConfirmCancel}
//             variant="contained"
//             sx={{ backgroundColor: '#dc2626', '&:hover': { backgroundColor: '#b91c1c' } }}
//           >
//             Exit Without Saving
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Dialog>
//   );
// };

// export default StockTransferInModal;

import { useEffect, useState } from 'react';
import { fetchData } from '../../../apiService';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Grid, Typography, Box, IconButton,
  FormControl, InputLabel, Select, MenuItem, Divider,
  useMediaQuery, useTheme, FormHelperText, Snackbar, Alert,
  CircularProgress, Backdrop, Autocomplete
} from '@mui/material';
import { Close, Add, Delete, Inventory, Visibility, CheckCircle, Warning } from '@mui/icons-material';

const StockTransferInModal = ({
  open,
  onClose,
  modalAction,
  formData,
  setFormData,
  transferDetails,
  setTransferDetails,
  onSave,
  items,
  branches,
  loading,
  companyId,
  branchId,
  token,
  onAccept,
  onReject
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [itemsModalOpen, setItemsModalOpen] = useState(false);

  // Validation state
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  // Cancel confirmation modal state
  const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const isViewMode = modalAction === 'view';
  const title = modalAction === 'create' ? 'Create Stock Transfer In' : modalAction === 'edit' ? 'Edit Stock Transfer In' : 'View Stock Transfer In';

  // Reset errors when modal opens/closes
  useEffect(() => {
    if (open) {
      setErrors({});
      setTouched({});
      setSnackbar({ open: false, message: '', severity: 'error' });
      setHasUnsavedChanges(false);
      setCancelConfirmOpen(false);
    }
  }, [open, modalAction]);

  const showError = (message) => {
    setSnackbar({ open: true, message, severity: 'error' });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  // Handle cancel with confirmation
  const handleCancelClick = () => {
    if (hasUnsavedChanges && !isViewMode) {
      setCancelConfirmOpen(true);
    } else {
      onClose();
    }
  };

  const handleConfirmCancel = () => {
    setCancelConfirmOpen(false);
    setHasUnsavedChanges(false);
    onClose();
  };

  const handleStayOnPage = () => {
    setCancelConfirmOpen(false);
  };

  // Validation rules
  const validateField = (field, value) => {
    switch (field) {
      case 'TransferNumber':
        if (!value || value.toString().trim() === '') return 'Transfer Number is required';
        return '';
      case 'TransferDate':
        if (!value) return 'Transfer Date is required';
        return '';
      case 'FromBranchId':
        if (!value) return 'From Branch is required';
        return '';
      default:
        return '';
    }
  };

  // Validate all fields
  const validateForm = () => {
    const newErrors = {};

    // Required field validations
    const transferNumberError = validateField('TransferNumber', formData.TransferNumber);
    if (transferNumberError) newErrors.TransferNumber = transferNumberError;

    const transferDateError = validateField('TransferDate', formData.TransferDate);
    if (transferDateError) newErrors.TransferDate = transferDateError;

    const fromBranchError = validateField('FromBranchId', formData.FromBranchId);
    if (fromBranchError) newErrors.FromBranchId = fromBranchError;

    // Transfer details validation
    if (transferDetails.length === 0) {
      newErrors.transferDetails = 'At least one item is required';
    } else {
      const detailErrors = [];
      transferDetails.forEach((detail, index) => {
        const itemErrors = {};
        if (!detail.ItemId) itemErrors.ItemId = 'Item is required';
        if (!detail.Quantity || parseFloat(detail.Quantity) <= 0) {
          itemErrors.Quantity = 'Quantity must be greater than 0';
        }
        if (!detail.Rate || parseFloat(detail.Rate) <= 0) {
          itemErrors.Rate = 'Rate must be greater than 0';
        }
        if (Object.keys(itemErrors).length > 0) {
          detailErrors[index] = itemErrors;
        }
      });
      if (detailErrors.length > 0) {
        newErrors.details = detailErrors;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle field blur for touched state
  const handleBlur = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }));
    const error = validateField(field, formData[field]);
    setErrors(prev => ({ ...prev, [field]: error }));
  };

  // Handle save with validation
  const handleSaveWithValidation = () => {
    // Mark all fields as touched
    setTouched({ TransferNumber: true, TransferDate: true, FromBranchId: true });

    // Build validation error messages
    const validationMessages = [];

    if (!formData.TransferNumber || formData.TransferNumber.toString().trim() === '') {
      validationMessages.push('Transfer Number is required');
    }
    if (!formData.TransferDate) {
      validationMessages.push('Transfer Date is required');
    }
    if (!formData.FromBranchId) {
      validationMessages.push('From Branch is required');
    }
    if (transferDetails.length === 0) {
      validationMessages.push('At least one item is required');
    } else {
      // Check each item for Quantity and Rate
      const itemErrors = [];
      transferDetails.forEach((detail, index) => {
        if (!detail.ItemId) {
          itemErrors.push(`Row ${index + 1}: Item is required`);
        }
        if (!detail.Quantity || parseFloat(detail.Quantity) <= 0) {
          itemErrors.push(`Row ${index + 1}: Quantity is required`);
        }
        if (!detail.Rate || parseFloat(detail.Rate) <= 0) {
          itemErrors.push(`Row ${index + 1}: Rate is required`);
        }
      });
      if (itemErrors.length > 0) {
        validationMessages.push(...itemErrors);
      }
    }

    if (validationMessages.length > 0) {
      showError(validationMessages.join(' | '));
      validateForm();
      return;
    }

    if (validateForm()) {
      onSave();
    }
  };

  const handleChange = (field, value) => {
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }

    // Mark as having unsaved changes
    if (!isViewMode) {
      setHasUnsavedChanges(true);
    }

    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleDetailChange = (index, field, value) => {
    // Mark as having unsaved changes
    if (!isViewMode) {
      setHasUnsavedChanges(true);
    }

    const updatedDetails = [...transferDetails];

    if (['Quantity', 'Rate'].includes(field)) {
      if (value === '' || value === null || value === undefined) {
        updatedDetails[index] = { ...updatedDetails[index], [field]: '' };
        setTransferDetails(updatedDetails);
        calculateTotals(updatedDetails);
        return;
      }
      const validNumberRegex = /^\d*\.?\d*$/;
      if (!validNumberRegex.test(value)) return;
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue < 0) return;
    }

    updatedDetails[index] = { ...updatedDetails[index], [field]: value };

    if (['Quantity', 'Rate'].includes(field)) {
      const detail = updatedDetails[index];
      const quantity = Math.max(0, parseFloat(detail.Quantity) || 0);
      const rate = Math.max(0, parseFloat(detail.Rate) || 0);
      const amount = quantity * rate;

      updatedDetails[index] = {
        ...updatedDetails[index],
        Amount: amount
      };
    }
    setTransferDetails(updatedDetails);
    calculateTotals(updatedDetails);
  };

  const handleItemSelect = (index, itemId) => {
    // Check if item is already selected in another row
    const isDuplicate = transferDetails.some((detail, i) => 
      i !== index && detail.ItemId === parseInt(itemId)
    );
    
    if (isDuplicate) {
      showError('This item is already added to the table. Please select a different item.');
      return;
    }

    const selectedItem = items.find(i => i.Id === parseInt(itemId));
    if (selectedItem) {
      const updatedDetails = [...transferDetails];
      const quantity = parseFloat(updatedDetails[index].Quantity) || 0;
      const rate = selectedItem.PurchaseRate || selectedItem.Rate || 0;
      const amount = quantity * rate;

      updatedDetails[index] = {
        ...updatedDetails[index],
        ItemId: itemId,
        Rate: rate,
        Amount: amount
      };
      setTransferDetails(updatedDetails);
      calculateTotals(updatedDetails);
    }
  };

  const addDetailRow = () => {
    setHasUnsavedChanges(true);
    setTransferDetails([{
      Id: 0, 
      ItemId: '', 
      Quantity: 0, 
      Rate: 0, 
      Amount: 0, 
      IsActive: true
    }, ...transferDetails]);
  };

  const removeDetailRow = (index) => {
    setHasUnsavedChanges(true);
    const updatedDetails = transferDetails.filter((_, i) => i !== index);
    setTransferDetails(updatedDetails);
    calculateTotals(updatedDetails);
  };

  const calculateTotals = (details) => {
    const totals = details.reduce((acc, d) => ({
      TotalQuantity: acc.TotalQuantity + (parseFloat(d.Quantity) || 0),
      TotalAmount: acc.TotalAmount + (parseFloat(d.Amount) || 0)
    }), { TotalQuantity: 0, TotalAmount: 0 });

    setFormData(prev => ({
      ...prev,
      ...totals
    }));
  };

  useEffect(() => {
    // Auto-calculate totals when details change
    if (!isViewMode && transferDetails.length > 0) {
      calculateTotals(transferDetails);
    }
  }, [transferDetails.length]);

  const formatCurrency = (amt) => `₹${(amt || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  // Block minus key and 'e'/'E' in number inputs to prevent negative values
  const preventNegativeInput = (e) => {
    if (e.key === '-' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  const disabledFieldStyle = { '& .MuiInputBase-input.Mui-disabled': { color: '#5D4037', fontWeight: 700, WebkitTextFillColor: '#5D4037' } };

  // Handle View All Items modal opening
  const handleViewAllItemsOpen = () => {
    setItemsModalOpen(true);
  };

  const handleViewAllItemsClose = () => {
    setItemsModalOpen(false);
  };

  const compactInput = { '& .MuiInputBase-input': { py: 0.75, fontSize: '0.8rem' }, '& .MuiInputLabel-root': { fontSize: '0.8rem' }, ...(isViewMode && disabledFieldStyle) };

  return (
    <Dialog open={open} onClose={(e, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
        if (hasUnsavedChanges && !isViewMode) {
          setCancelConfirmOpen(true);
          return;
        }
      }
      onClose();
    }}
      maxWidth="xl" fullWidth fullScreen={isMobile} disableEscapeKeyDown
      PaperProps={{ sx: { borderRadius: isMobile ? 0 : '10px', m: isMobile ? 0 : 2, maxWidth: '1400px', position: 'relative' } }}>

      <DialogTitle sx={{ py: 1, px: 2, borderBottom: isViewMode ? '1px solid #e2e8f0' : '1px solid #d1d5db', bgcolor: isViewMode ? '#1e293b' : '#f8f4ff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Inventory sx={{ color: isViewMode ? '#f8fafc' : '#8b5cf6', fontSize: 20 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: isViewMode ? '#f8fafc' : '#5b21b6', fontSize: isMobile ? '0.9rem' : '1rem' }}>{title}</Typography>
          </Box>
          <IconButton onClick={handleCancelClick} size="small" sx={{ p: 0.5, color: isViewMode ? '#f8fafc' : 'inherit' }}><Close fontSize="small" /></IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: isMobile ? 1.5 : 2, bgcolor: isViewMode ? '#f8fafc' : '#fefffe' }}>
        <Typography variant="caption" sx={{ fontWeight: 600, color: isViewMode ? '#475569' : '#8b5cf6', mb: 1, display: 'block' }}>Transfer Information</Typography>
        <Grid container spacing={1} sx={{ mb: 1.5 }}>
          <Grid item xs={6} sm={2}>
            <TextField
              fullWidth
              size="small"
              label="Transfer No *"
              value={formData.TransferPrefix && formData.FinYear 
                ? `${formData.TransferPrefix}/${formData.TransferNumber}/${formData.FinYear}`
                : formData.TransferNumber || ''}
              onChange={(e) => handleChange('TransferNumber', e.target.value)}
              onBlur={() => handleBlur('TransferNumber')}
              disabled={isViewMode}
              error={touched.TransferNumber && !!errors.TransferNumber}
              helperText={touched.TransferNumber && errors.TransferNumber}
              sx={compactInput}
            />
          </Grid>
          <Grid item xs={6} sm={2}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="Transfer Date *"
              value={formData.TransferDate || ''}
              onChange={(e) => handleChange('TransferDate', e.target.value)}
              onBlur={() => handleBlur('TransferDate')}
              disabled={isViewMode}
              error={touched.TransferDate && !!errors.TransferDate}
              helperText={touched.TransferDate && errors.TransferDate}
              InputLabelProps={{ shrink: true }}
              sx={compactInput}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            {isViewMode ? (
              <TextField fullWidth size="small" label="From Branch" value={branches.find(b => b.Id === formData.FromBranchId)?.Name || '-'} disabled sx={{ ...compactInput, ...disabledFieldStyle }} />
            ) : (
              <FormControl fullWidth size="small" sx={compactInput} error={touched.FromBranchId && !!errors.FromBranchId}>
                <InputLabel>From Branch *</InputLabel>
                <Select
                  value={formData.FromBranchId || ''}
                  onChange={(e) => handleChange('FromBranchId', e.target.value)}
                  onBlur={() => handleBlur('FromBranchId')}
                  label="From Branch *"
                  sx={{ fontSize: '0.8rem' }}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.85rem' } } } }}
                >
                  {branches.filter(b => b.Id !== branchId).map(branch => (
                    <MenuItem key={branch.Id} value={branch.Id} sx={{ fontSize: '0.85rem', py: 0.5 }}>
                      {branch.Name}
                    </MenuItem>
                  ))}
                </Select>
                {touched.FromBranchId && errors.FromBranchId && (
                  <FormHelperText>{errors.FromBranchId}</FormHelperText>
                )}
              </FormControl>
            )}
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              fullWidth
              size="small"
              label="Remarks"
              value={formData.Remarks || ''}
              onChange={(e) => handleChange('Remarks', e.target.value)}
              disabled={isViewMode}
              sx={compactInput}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color: errors.transferDetails ? '#dc2626' : (isViewMode ? '#475569' : '#8b5cf6') }}>Transfer Items *</Typography>
            <Typography variant="caption" sx={{ color: '#6b7280' }}>({transferDetails.length} items)</Typography>
            {errors.transferDetails && (
              <Typography variant="caption" sx={{ color: '#dc2626', fontSize: '0.7rem' }}>({errors.transferDetails})</Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {transferDetails.length > 5 && (
              <Button
                size="small"
                onClick={handleViewAllItemsOpen}
                startIcon={<Visibility sx={{ fontSize: 14 }} />}
                sx={{ py: 0.25, px: 1, fontSize: '0.7rem', minHeight: 0, color: '#1e40af' }}
              >
                View All
              </Button>
            )}
            {/* {!isViewMode && (
              <Button size="small" startIcon={<Add sx={{ fontSize: 16 }} />} onClick={addDetailRow} variant="outlined" sx={{ py: 0.25, px: 1, fontSize: '0.7rem', minHeight: 0 }}>Add</Button>
            )} */}
          </Box>
        </Box>

        {/* Desktop Table View - Fixed height for 5 rows */}
        {!isMobile && (
          <Box sx={{ maxHeight: 200, overflow: 'auto', mb: 1.5, border: errors.transferDetails ? '1px solid #dc2626' : (isViewMode ? '1px solid #e2e8f0' : '1px solid #d1d5db'), borderRadius: 1 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
              <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <tr style={{ background: isViewMode ? 'linear-gradient(135deg, #334155 0%, #1e293b 100%)' : 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
                  <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #d1d5db', width: '4%', background: 'transparent', color: 'white', fontWeight: 600 }}>Sl No</th>
                  <th style={{ padding: '6px 8px', textAlign: 'left', borderBottom: '1px solid #d1d5db', width: '40%', background: 'transparent', color: 'white', fontWeight: 600 }}>Item</th>
                  <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #d1d5db', width: '15%', background: 'transparent', color: 'white', fontWeight: 600 }}>Quantity</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', borderBottom: '1px solid #d1d5db', width: '15%', background: 'transparent', color: 'white', fontWeight: 600 }}>Rate</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', borderBottom: '1px solid #d1d5db', width: '20%', background: 'transparent', color: 'white', fontWeight: 600 }}>Amount</th>
                  {!isViewMode && <th style={{ padding: '6px 8px', textAlign: 'center', borderBottom: '1px solid #d1d5db', width: '6%', background: 'transparent', color: 'white', fontWeight: 600 }}></th>}
                </tr>
              </thead>
              <tbody>
                {transferDetails.map((d, index) => (
                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? (isViewMode ? '#f1f5f9' : '#f8f4ff') : '#ffffff' }}>
                    <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'center', fontWeight: 600, color: isViewMode ? '#475569' : '#8b5cf6' }}>
                      {index + 1}
                    </td>
                    {/* <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', fontWeight: isViewMode ? 600 : 400 }}>
                      {isViewMode ? (
                        <span style={{ fontWeight: 600, color: '#5b21b6' }}>{items.find(i => i.Id === parseInt(d.ItemId))?.Name || '-'}</span>
                      ) : (
                        <Select fullWidth size="small" value={d.ItemId || ''} onChange={(e) => handleItemSelect(index, e.target.value)} sx={{ fontSize: '0.85rem', '& .MuiSelect-select': { py: 0.5 } }} MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.85rem' } } } }}>
                          <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}>Select</MenuItem>
                          {items.map(item => {
                            const isAlreadySelected = transferDetails.some((detail, i) => 
                              i !== index && detail.ItemId === item.Id
                            );
                            return (
                              <MenuItem 
                                key={item.Id} 
                                value={item.Id} 
                                disabled={isAlreadySelected}
                                sx={{ 
                                  fontSize: '0.85rem', 
                                  py: 0.25,
                                  opacity: isAlreadySelected ? 0.5 : 1,
                                  color: isAlreadySelected ? '#9ca3af' : 'inherit'
                                }}
                              >
                                {item.Name} {isAlreadySelected && '(Already Added)'}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    </td> */}
                    <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', fontWeight: isViewMode ? 600 : 400 }}>
                        <span style={{ fontWeight: 600, color: '#5b21b6' }}>{items.find(i => i.Id === parseInt(d.ItemId))?.Name || '-'}</span>
                    </td>
                    <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'center', fontWeight: isViewMode ? 600 : 400 }}>
                      {isViewMode ? (
                        <span style={{ fontWeight: 600, color: '#5b21b6' }}>{d.Quantity || 0}</span>
                      ) : (
                        <TextField size="small" type="number" value={d.Quantity ?? ''} onChange={(e) => handleDetailChange(index, 'Quantity', e.target.value)} disabled={isViewMode} onFocus={(e) => e.target.select()} onKeyDown={preventNegativeInput} inputProps={{ min: 0, style: { textAlign: 'center', padding: '4px', fontSize: '0.75rem' } }} sx={{ width: '100%' }} />
                      )}
                    </td>
                    <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'right', fontWeight: isViewMode ? 600 : 400 }}>
                      {isViewMode ? (
                        <span style={{ fontWeight: 600, color: '#5b21b6' }}>{formatCurrency(d.Rate)}</span>
                      ) : (
                        <TextField size="small" type="number" value={d.Rate ?? ''} onChange={(e) => handleDetailChange(index, 'Rate', e.target.value)} disabled={isViewMode} onFocus={(e) => e.target.select()} onKeyDown={preventNegativeInput} inputProps={{ min: 0, style: { textAlign: 'right', padding: '4px', fontSize: '0.75rem' } }} sx={{ width: '100%' }} />
                      )}
                    </td>
                    <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'right', fontWeight: 600, color: '#8b5cf6' }}>{formatCurrency(d.Amount)}</td>
                    {!isViewMode && (
                      <td style={{ padding: '4px 8px', borderBottom: '1px solid #d1d5db', textAlign: 'center' }}>
                        <IconButton size="small" onClick={() => removeDetailRow(index)} sx={{ p: 0.25, color: '#dc2626' }}><Delete sx={{ fontSize: 16 }} /></IconButton>
                      </td>
                    )}
                  </tr>
                ))}
                {transferDetails.length === 0 && (
                  <tr><td colSpan={isViewMode ? 5 : 6} style={{ padding: '20px', textAlign: 'center', color: '#6b7280', backgroundColor: isViewMode ? '#f1f5f9' : '#f8f4ff' }}>No items added</td></tr>
                )}
              </tbody>
            </table>
          </Box>
        )}

        {/* Mobile Card View */}
        {isMobile && (
          <Box sx={{ maxHeight: 300, overflow: 'auto', mb: 1.5 }}>
            {transferDetails.map((d, index) => (
              <Box key={index} sx={{ border: '1px solid #d1d5db', borderRadius: 2, p: 1.5, mb: 1.5, bgcolor: '#f8f4ff' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.8rem' }}>
                    {items.find(i => i.Id === parseInt(d.ItemId))?.Name || 'Select Item'}
                  </Typography>
                  {!isViewMode && (
                    <IconButton size="small" onClick={() => removeDetailRow(index)} sx={{ p: 0.5, bgcolor: '#fef2f2', color: '#dc2626' }}><Delete sx={{ fontSize: 16 }} /></IconButton>
                  )}
                </Box>
                {!isViewMode && (
                  <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                    <InputLabel sx={{ fontSize: '0.75rem' }}>Select Item</InputLabel>
                    <Select value={d.ItemId || ''} onChange={(e) => handleItemSelect(index, e.target.value)} label="Select Item" sx={{ fontSize: '0.85rem' }} MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.85rem' } } } }}>
                      {items.map(item => {
                        const isAlreadySelected = transferDetails.some((detail, i) => 
                          i !== index && detail.ItemId === item.Id
                        );
                        return (
                          <MenuItem 
                            key={item.Id} 
                            value={item.Id} 
                            disabled={isAlreadySelected}
                            sx={{ 
                              fontSize: '0.85rem', 
                              py: 0.5,
                              opacity: isAlreadySelected ? 0.5 : 1,
                              color: isAlreadySelected ? '#9ca3af' : 'inherit'
                            }}
                          >
                            {item.Name} {isAlreadySelected && '(Already Added)'}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                )}
                <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: '#8b5cf6', fontSize: '0.65rem', fontWeight: 600 }}>Quantity</Typography>
                    <TextField size="small" type="number" value={d.Quantity || ''} onChange={(e) => handleDetailChange(index, 'Quantity', e.target.value)} disabled={isViewMode} fullWidth onKeyDown={preventNegativeInput} inputProps={{ min: 0 }} sx={{ '& .MuiInputBase-input': { py: 0.75, fontSize: '0.8rem', textAlign: 'center' } }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="caption" sx={{ color: '#8b5cf6', fontSize: '0.65rem', fontWeight: 600 }}>Rate</Typography>
                    <TextField size="small" type="number" value={d.Rate || ''} onChange={(e) => handleDetailChange(index, 'Rate', e.target.value)} disabled={isViewMode} fullWidth onKeyDown={preventNegativeInput} inputProps={{ min: 0 }} sx={{ '& .MuiInputBase-input': { py: 0.75, fontSize: '0.8rem', textAlign: 'right' } }} />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 1, borderTop: '1px solid #d1d5db' }}>
                  <Typography variant="caption" sx={{ color: '#8b5cf6', fontWeight: 600 }}>Amount</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#8b5cf6' }}>{formatCurrency(d.Amount)}</Typography>
                </Box>
              </Box>
            ))}
            {transferDetails.length === 0 && (
              <Box sx={{ textAlign: 'center', py: 4, color: '#8b5cf6', bgcolor: '#f8f4ff', borderRadius: 1, border: '1px dashed #d1d5db' }}><Typography variant="body2">No items added</Typography></Box>
            )}
          </Box>
        )}

        <Divider sx={{ my: 1 }} />

        {/* Summary Section */}
        <Grid container spacing={1}>
          <Grid item xs={12} sm={8}>
            {/* Audit Info */}
            {isViewMode && (
              <Box sx={{ bgcolor: '#f1f5f9', p: 1.5, borderRadius: 1 }}>
                {(formData.InputAccepted != null || formData.InputRejected != null) && (
                  <Box sx={{ display: 'flex', gap: 2, mb: 1, pb: 1, borderBottom: '1px solid #e2e8f0' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <CheckCircle sx={{ fontSize: 14, color: '#16a34a' }} />
                      <Typography variant="caption" sx={{ color: '#16a34a', fontWeight: 600 }}>Accepted: {formData.InputAccepted ?? 0}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Warning sx={{ fontSize: 14, color: formData.InputRejected > 0 ? '#dc2626' : '#9ca3af' }} />
                      <Typography variant="caption" sx={{ color: formData.InputRejected > 0 ? '#dc2626' : '#9ca3af', fontWeight: 600 }}>Rejected: {formData.InputRejected ?? 0}</Typography>
                    </Box>
                  </Box>
                )}
                <Typography variant="caption" sx={{ color: '#6b7280', display: 'block' }}>
                  Created by <Typography component="span" variant="caption" sx={{ fontWeight: 600, color: '#8b5cf6' }}>{formData.CreatedByName || '-'}</Typography> on{' '}
                  <Typography component="span" variant="caption" sx={{ color: '#7c3aed' }}>
                    {formData.CreatedDate ? new Date(formData.CreatedDate).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ', ' + new Date(formData.CreatedDate).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}
                  </Typography>
                </Typography>
                <Typography variant="caption" sx={{ color: '#6b7280', display: 'block' }}>
                  Modified by <Typography component="span" variant="caption" sx={{ fontWeight: 600, color: '#7c3aed' }}>{formData.ModifiedByName || '-'}</Typography> on{' '}
                  <Typography component="span" variant="caption" sx={{ color: '#6d28d9' }}>
                    {formData.ModifiedDate ? new Date(formData.ModifiedDate).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ', ' + new Date(formData.ModifiedDate).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}
                  </Typography>
                </Typography>
              </Box>
            )}
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="caption" sx={{ fontWeight: 600, color: isViewMode ? '#475569' : '#8b5cf6', mb: 1, display: 'block' }}>Summary</Typography>
            <Box sx={{ bgcolor: isViewMode ? '#f1f5f9' : '#f8f4ff', p: 1.5, borderRadius: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="caption">Total Quantity</Typography>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#8b5cf6' }}>{formData.TotalQuantity || 0}</Typography>
              </Box>
              <Divider sx={{ my: 0.5 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Total Amount</Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#8b5cf6' }}>{formatCurrency(formData.TotalAmount)}</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.5, borderTop: isViewMode ? '1px solid #e2e8f0' : '1px solid #d1d5db', bgcolor: isViewMode ? '#f8fafc' : '#f8f4ff' }}>
        <Button onClick={handleCancelClick} variant="outlined" size="small">Cancel</Button>
        {isViewMode && onAccept && !formData.InputAccepted && (
          <Button onClick={() => onAccept(formData.Id)} variant="contained" size="small"
            sx={{ bgcolor: '#16a34a', '&:hover': { bgcolor: '#15803d' }, textTransform: 'none' }}>
            Accept
          </Button>
        )}
        {isViewMode && onReject && !formData.InputAccepted && (
          <Button onClick={() => onReject(formData.Id)} variant="contained" size="small"
            sx={{ bgcolor: '#dc2626', '&:hover': { bgcolor: '#b91c1c' }, textTransform: 'none' }}>
            Reject
          </Button>
        )}
        {!isViewMode && <Button onClick={handleSaveWithValidation} variant="contained" size="small" disabled={loading}>Save</Button>}
      </DialogActions>

      {/* View All Items Modal */}
      <Dialog 
        open={itemsModalOpen} 
        onClose={handleViewAllItemsClose} 
        maxWidth="lg"
        fullWidth 
        PaperProps={{ 
          sx: { 
            borderRadius: '12px', 
            maxHeight: '90vh', 
            position: 'relative', 
            m: 1
          } 
        }}
      >
        <DialogTitle sx={{ py: 1, px: 1.5, borderBottom: '1px solid #d1d5db', bgcolor: '#f8f4ff' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Inventory sx={{ color: '#8b5cf6', fontSize: 18 }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.9rem' }}>All Transfer Items ({transferDetails.length})</Typography>
            </Box>
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {!isViewMode && (
                <Button 
                  onClick={addDetailRow} 
                  variant="contained" 
                  size="small" 
                  startIcon={<Add sx={{ fontSize: 14 }} />}
                  sx={{ 
                    bgcolor: '#8b5cf6', 
                    '&:hover': { bgcolor: '#7c3aed' },
                    fontSize: '0.7rem',
                    py: 0.4,
                    px: 1,
                    minHeight: 0
                  }}
                >
                  Add Item
                </Button>
              )}
              <IconButton onClick={handleViewAllItemsClose} size="small" sx={{ p: 0.4 }}><Close fontSize="small" /></IconButton>
            </Box> */}
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
              <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <tr style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
                  <th style={{ padding: '8px 6px', textAlign: 'center', color: 'white', fontWeight: 600, fontSize: '0.7rem' }}>#</th>
                  <th style={{ padding: '8px 8px', textAlign: 'left', color: 'white', fontWeight: 600, fontSize: '0.7rem', minWidth: '200px' }}>Item Name</th>
                  <th style={{ padding: '8px 6px', textAlign: 'center', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '100px' }}>Quantity</th>
                  <th style={{ padding: '8px 6px', textAlign: 'right', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '100px' }}>Rate</th>
                  <th style={{ padding: '8px 6px', textAlign: 'right', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '120px' }}>Amount</th>
                  {!isViewMode && <th style={{ padding: '8px 6px', textAlign: 'center', color: 'white', fontWeight: 600, fontSize: '0.7rem', width: '50px' }}>Action</th>}
                </tr>
              </thead>
              <tbody>
                {transferDetails.map((d, index) => (
                  <tr key={index} style={{ background: index % 2 === 0 ? '#f8f4ff' : '#ffffff', borderBottom: '1px solid #d1d5db' }}>
                    <td style={{ padding: '6px', textAlign: 'center', fontWeight: 500, color: '#8b5cf6', fontSize: '0.75rem' }}>{index + 1}</td>
                    <td style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 500, color: '#5b21b6' }}>
                      {isViewMode ? (
                        <span style={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.75rem' }}>{items.find(i => i.Id === parseInt(d.ItemId))?.Name || '-'}</span>
                      ) : (
                        <Select 
                          fullWidth 
                          size="small" 
                          value={d.ItemId || ''} 
                          onChange={(e) => handleItemSelect(index, e.target.value)} 
                          sx={{ 
                            fontSize: '0.75rem', 
                            minWidth: '180px',
                            '& .MuiSelect-select': { py: 0.4, fontSize: '0.75rem' } 
                          }} 
                          MenuProps={{ PaperProps: { sx: { maxHeight: 200, '& .MuiMenuItem-root': { fontSize: '0.75rem', py: 0.4 } } } }}
                        >
                          <MenuItem value="" disabled sx={{ fontSize: '0.75rem' }}>Select Item</MenuItem>
                          {items.map(item => {
                            const isAlreadySelected = transferDetails.some((detail, i) => 
                              i !== index && detail.ItemId === item.Id
                            );
                            return (
                              <MenuItem 
                                key={item.Id} 
                                value={item.Id} 
                                disabled={isAlreadySelected}
                                sx={{ 
                                  fontSize: '0.75rem', 
                                  py: 0.2,
                                  opacity: isAlreadySelected ? 0.5 : 1,
                                  color: isAlreadySelected ? '#9ca3af' : 'inherit'
                                }}
                              >
                                {item.Name} {isAlreadySelected && '(Already Added)'}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    </td>
                    <td style={{ padding: '6px', textAlign: 'center', fontWeight: 600, color: '#5b21b6' }}>
                      {isViewMode ? (
                        <span style={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.75rem' }}>{d.Quantity || 0}</span>
                      ) : (
                        <TextField 
                          size="small" 
                          type="number" 
                          value={d.Quantity ?? ''} 
                          onChange={(e) => handleDetailChange(index, 'Quantity', e.target.value)} 
                          onFocus={(e) => e.target.select()}
                          onKeyDown={preventNegativeInput}
                          inputProps={{ 
                            min: 0, 
                            style: { textAlign: 'center', padding: '3px', fontSize: '0.7rem' },
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                e.target.blur();
                              }
                            }
                          }} 
                          sx={{ 
                            width: '80px', 
                            '& .MuiOutlinedInput-root': { height: '28px' },
                            '& input': {
                              transition: 'none'
                            }
                          }} 
                        />
                      )}
                    </td>
                    <td style={{ padding: '6px', textAlign: 'right', fontWeight: 600, color: '#5b21b6' }}>
                      {isViewMode ? (
                        <span style={{ fontWeight: 600, color: '#5b21b6', fontSize: '0.75rem' }}>{formatCurrency(d.Rate)}</span>
                      ) : (
                        <TextField 
                          size="small" 
                          type="number" 
                          value={d.Rate ?? ''} 
                          onChange={(e) => handleDetailChange(index, 'Rate', e.target.value)} 
                          onFocus={(e) => e.target.select()}
                          onKeyDown={preventNegativeInput}
                          inputProps={{ 
                            min: 0, 
                            style: { textAlign: 'right', padding: '3px', fontSize: '0.7rem' },
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                e.target.blur();
                              }
                            }
                          }} 
                          sx={{ 
                            width: '90px', 
                            '& .MuiOutlinedInput-root': { height: '28px' },
                            '& input': {
                              transition: 'none'
                            }
                          }} 
                        />
                      )}
                    </td>
                    <td style={{ padding: '6px', textAlign: 'right', fontWeight: 700, color: '#8b5cf6', fontSize: '0.75rem' }}>{formatCurrency(d.Amount)}</td>
                    {!isViewMode && (
                      <td style={{ padding: '6px', textAlign: 'center' }}>
                        <IconButton 
                          size="small" 
                          onClick={() => removeDetailRow(index)} 
                          sx={{ p: 0.2, color: '#dc2626', '&:hover': { bgcolor: '#fef2f2' } }}
                        >
                          <Delete sx={{ fontSize: 14 }} />
                        </IconButton>
                      </td>
                    )}
                  </tr>
                ))}
                {transferDetails.length === 0 && (
                  <tr>
                    <td colSpan={isViewMode ? 5 : 6} style={{ padding: '16px', textAlign: 'center', color: '#6b7280', backgroundColor: '#f8f4ff', fontSize: '0.8rem' }}>
                      No items added
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot style={{ position: 'sticky', bottom: 0, background: 'linear-gradient(135deg, #e9d5ff 0%, #ddd6fe 100%)' }}>
                <tr style={{ borderTop: '2px solid #8b5cf6' }}>
                  <td colSpan="2" style={{ padding: '8px 6px', fontWeight: 700, textAlign: 'right', color: '#5b21b6', fontSize: '0.75rem' }}>Totals:</td>
                  <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 700, color: '#8b5cf6', fontSize: '0.75rem' }}>{transferDetails.reduce((sum, d) => sum + (parseFloat(d.Quantity) || 0), 0)}</td>
                  <td colSpan="1"></td>
                  <td style={{ padding: '8px 6px', textAlign: 'right', fontWeight: 700, color: '#8b5cf6', fontSize: '0.75rem' }}>{formatCurrency(transferDetails.reduce((sum, d) => sum + (parseFloat(d.Amount) || 0), 0))}</td>
                  {!isViewMode && <td style={{ padding: '8px 6px' }}></td>}
                </tr>
              </tfoot>
            </table>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 1.5, py: 1, borderTop: '1px solid #d1d5db', bgcolor: '#f8f4ff', justifyContent: 'flex-end' }}>
          <Button onClick={handleViewAllItemsClose} variant="outlined" size="small" sx={{ fontSize: '0.75rem', py: 0.4, px: 1.5 }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Validation Error Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Cancel Confirmation Modal */}
      <Dialog
        open={cancelConfirmOpen}
        onClose={handleStayOnPage}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: '12px', padding: '8px' } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{
              backgroundColor: '#fef3c7',
              borderRadius: '50%',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Warning sx={{ color: '#f59e0b', fontSize: 24 }} />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b' }}>
              Unsaved Changes
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#64748b', fontSize: '0.9rem' }}>
            You have unsaved changes that will be lost if you leave this page.
          </Typography>
          <Typography sx={{ color: '#dc2626', fontSize: '0.85rem', mt: 1, fontWeight: 500 }}>
            Are you sure you want to exit without saving?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            onClick={handleStayOnPage}
            variant="outlined"
            sx={{
              borderColor: '#8b5cf6',
              color: '#8b5cf6',
              '&:hover': { borderColor: '#7c3aed', backgroundColor: '#f8f4ff' }
            }}
          >
            Stay on Page
          </Button>
          <Button
            onClick={handleConfirmCancel}
            variant="contained"
            sx={{ backgroundColor: '#dc2626', '&:hover': { backgroundColor: '#b91c1c' } }}
          >
            Exit Without Saving
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default StockTransferInModal;
